import React, { useState,useEffect,useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../../components/PayByFaceModel/paybyfacemodel.css";
import "./enquiry.css";
import mainImg from "../../assets/img/enquiry/head.jpg";
import one from "../../assets/img/enquiry/1.jpg";
import two from "../../assets/img/enquiry/2.jpg";
import three from "../../assets/img/enquiry/3.jpg";
import four from "../../assets/img/enquiry/4.jpg";
import five from "../../assets/img/enquiry/5.jpg";
import thankyouImg from "../../assets/img/enquiry/thankyou.jpg";
import { emailValidation } from "../../assets/utils/constFuntion";
import { Modal, UncontrolledCarousel } from "reactstrap";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import queryString from "query-string";

// import Translate from "../../assets/js/translate.min.js"
import { css } from "jquery";

export const Enquiry = () => {

  const [isOpen, setIsOpen] = useState(true)
   const ref = useRef(null);

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
        includedLanguages: 'en,kn'
      },
      "google_translate_element"
    );
  };
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;

    // setIsOpen(true)

    //isOpen === true  ? document.body.classList.add('lang') : document.body.classList.remove('lang');

      if(isOpen === true){
        document.body.classList.add('lang');
      }
      else{
        document.body.classList.remove('lang');
      }

      // if (document.getElementById("google_translate_element").classList.contains("skiptranslate.goog-te-gadget")) {
      //     document.getElementsByClassName("trans-label").style.display = "block";
      // } else {
       
      // }

  }, []);

  const [input, setInput] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
    firstNameError: false,
    mobileNumberError: false,
    industryTypeError: false,
    emailError: false,
    cityNameError: false,
  });
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [failedRes, setFailedRes] = useState("");
  const [disable,setDisable] = useState(false);
  const history = useHistory();
  // const params = useParams();
  const params = queryString.parse(window.location.search);

  console.log("params", params);

  const onInputChange = (e) => {
    const value = e.target.value;
    // handleMobileNumber();
    setInput({
      ...input,
      [e.target.name]: value,
    });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!handleEmailValidation()) {
      return false;
    }
    const data = {
     name: input.name,
      phone: input.phone,
      email: input.email,
      // ...(input.email.length > 0 && { email: input.email }),
      city: input.city,
      utm_landing_page: "https://www.safexpay.com/enquiry",
      date_of_reg: new Date().toLocaleString(),
      utm_visits:"",
      ...params,
    };

  //   const data = {
  //   name:input.name,
  //   phone: input.phone,
  //   email:input.email,
  //   city:input.city,
  //   utm_source:"GOOGLE",
  //   utm_medium:"SEO",
  //   utm_campaign:"CampLive",
  //   utm_landing_page:"https://www.safexpay.com/enquiry",
  //   utm_visits:"",
  //   utm_content:"Advertise",
  //   date_of_reg: new Date().toLocaleString(),
  // } 

    const response = await axios.post(
      `https://www.avantgardepayments.com/agmerchant/api/campaign`,
      data
    );
    if (response.data.status === "Success") {
      toggleModel();
      history.push({
        pathname: "/enquiry",
        search: "?success",
      });
    }else{
      //console.log(response);
      setFailedRes(response.data.status)
      toggleModel1();
    }
  };
  const toggleModel = () => {
    setOpen(!open);
  };

  const toggleModel1 = () => {
    setOpen1(!open1);
  };

  //  const handleEmail = () => {
  //   // if (
  //   //   emailValidation(input.email.trim())) {
  //   //   document.getElementById("txtEmail").classList.add("invalid");
  //   //     input.emailError = true;
  //   //     if(input.emailError){
  //   //    document.getElementById("emailinp").classList.remove("showerr");
  //   //    }
  //   //     return false;
  //   //  } else {
  //   //   document.getElementById("txtEmail").classList.remove("invalid");
  //   //   document.getElementById("emailinp").classList.add("showerr");
  //   //   input.emailError = false;
  //   //   return true;
  //   // }
  //   if(emailValidation(input.email.trim())) {
  //     document.getElementById("emailinp").classList.remove("showerr");
  //     input.emailError = false;
  //     return true;
  //   }
  // };

  const handleEmailValidation = () => {
    if (!emailValidation(input.email.trim()) && input.email.length > 0) {
      document.getElementById("txtEmail").classList.add("invalid");
      input.emailError = true;
      if (input.emailError) {
        document.getElementById("emailinp").classList.remove("showerr");
        setDisable(true);
      } else {
        document.getElementById("emailinp").classList.add("showerr");
        setDisable(false);

      }
      return false;
    } else {
      document.getElementById("txtEmail").classList.remove("invalid");
      document.getElementById("emailinp").classList.add("showerr");
      input.emailError = false;
      return true;
    }
  };

  const handleFullName = () => {
    let reg = /^[a-zA-Z\-_.'\s]{1,50}$/;
    if (!reg.test(input.name.trim())) {
      input.firstNameError = true;
      document.getElementById("txtFirstName").classList.add("invalid");
      if (input.firstNameError || input.name === "") {
        document.getElementById("nameinp").classList.remove("showerr");
        setDisable(true);
      }
      return false;
    } else {
      input.firstNameError = false;
      document.getElementById("txtFirstName").classList.remove("invalid");
      document.getElementById("nameinp").classList.add("showerr");
       setDisable(false);
      return true;
    }
  };

  const handleCity = () => {
    let reg = /^[a-zA-Z\-_.'\s]{1,50}$/;
    if (!reg.test(input.city.trim())) {
      input.cityNameError = true;
      document.getElementById("txtCity").classList.add("invalid");
      if (input.cityNameError || input.name === "") {
        document.getElementById("cityinp").classList.remove("showerr");
        setDisable(true);
      }
      return false;
    } else {
      input.cityNameError = false;
      document.getElementById("txtCity").classList.remove("invalid");
      document.getElementById("cityinp").classList.add("showerr");
       setDisable(false);
      return true;
    }
  };

  const handleMobileNumber = (e) => {
    const contactRe = /^[6-9]{1}[0-9]{9}$/;
    // const ind = input.phone.slice(0, 2);
    const phone = input.phone.slice(0, 10);
    // if (ind === "91")

    if (!contactRe.test(phone) || !phone.trim()) {
      input.mobileNumberError = true;
      document.getElementById("txtMobile").classList.add("invalid");
      if (input.mobileNumberError || input.phone === "") {
        document.getElementById("phoneinp").classList.remove("showerr");
        setDisable(true);
      }
      return false;
    } else {
      input.mobileNumberError = false;
      document.getElementById("txtMobile").classList.remove("invalid");
      document.getElementById("phoneinp").classList.add("showerr");
       setDisable(false);
      return true;
    }
    // }
  };

  return (
    <>
      <div className="row enquiry-row">
        <div className="col-md-7">
          <img className="img-fluid" src={mainImg} alt="" />
        </div>
        <div className="col-md-5">
        <div id="google_translate_element">
          <label className="trans-label">Select Language</label>
        </div>
          <div className="main-form-ele p-3">
            <h6 className="enquiry-heading">Get to know more!</h6>
            <h6 className="enquiry-heading">For business enquiries,</h6>
            <h6 className="enquiry-heading">Fill in your details here.</h6>
            <form className="form-enquiry pt-3" onSubmit={onSubmit}>
              <div className="forminpt">
                <label>
                  Name <span className="req">*</span>
                </label>
                <input
                  id="txtFirstName"
                  type="text"
                  className="paybyface-inputs"
                  onChange={onInputChange}
                  placeholder="Enter Name"
                  name="name"
                  onKeyUp={handleFullName}
                  required
                />
                <small
                  className="showerr"
                  id="nameinp"
                  style={{ color: "red" }}
                >
                  Please enter valid name.
                </small>
              </div>
              <div className="forminpt">
                <label>
                  Phone no. <span className="req">*</span>
                </label>
                <input
                  id="txtMobile"
                  type="number"
                  maxLength="10"
                  className="paybyface-inputs"
                  placeholder="Enter Phone no."
                  onChange={onInputChange}
                  onInput={(e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, 10);
                  }}
                  onKeyUp={handleMobileNumber}
                  name="phone"
                  required
                />
                <small
                  id="phoneinp"
                  className="showerr"
                  style={{ color: "red" }}
                >
                  Please enter valid phone no.
                </small>
              </div>
              <div className="forminpt">
                <label>
                  Email <span className="req">*</span>
                </label>
                <input
                  id="txtEmail"
                  type="email"
                  className="paybyface-inputs"
                  placeholder="Enter Email"
                  onChange={onInputChange}
                  name="email"
                  onKeyUp={handleEmailValidation}
                  required
                />
                <small
                  id="emailinp"
                  className="showerr"
                  style={{ color: "red" }}
                >
                  Please enter valid email.
                </small>
              </div>
              <div className="forminpt">
                <label>
                  City <span className="req">*</span>
                </label>
                <input
                  id="txtCity"
                  type="text"
                  className="paybyface-inputs"
                  placeholder="Enter City"
                  onChange={onInputChange}
                  name="city"
                  onKeyUp={handleCity}
                  required
                />
                <small
                  id="cityinp"
                  className="showerr"
                  style={{ color: "red" }}
                >
                  Please enter valid city name.
                </small>
              </div>
              <input type="hidden" name="utm_source" value="" />
              <input type="hidden" name="utm_medium" value="" />
              <input type="hidden" name="utm_campaign" value="" />
              <input type="hidden" name="utm_content" value="" />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button className="btn btn-blue-rounded" disabled={disable}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="main-form-ele">
              <h6 className="enquiry-heading">About Safexpay</h6>
              <p className="para">
                Safexpay, the fastest growing fintech in India which specialises
                in tailor made payments platform for businesses of various
                sector companies is focussed on pioneering top fintech
                innovation for the world with its comprehensive, robust and
                innovative solutions including White label suite of Payment
                Aggregation Platform & Neo-banking. The Omni channel payment
                platform offerings is well accepted by its customers in
                Government, Education, E-Commerce, Banks, Fintech & all other
                industries.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <UncontrolledCarousel
              items={[
                {
                  altText: "Slide 1",
                  caption: "*",
                  key: 1,
                  src: one,
                },
                {
                  altText: "Slide 2",
                  caption: "*",
                  key: 2,
                  src: two,
                },
                {
                  altText: "Slide 3",
                  caption: "*",
                  key: 3,
                  src: three,
                },
                {
                  altText: "Slide 3",
                  caption: "*",
                  key: 4,
                  src: four,
                },
                {
                  altText: "Slide 3",
                  caption: "*",
                  key: 5,
                  src: five,
                },
              ]}
            />
          </div>
        </div>
      </div>
      <footer className="footer-enquiry mt-3">
        <div className="container-fluid">
          <div className="col-md-12 ">
            <p>&#169; All Rights Reserved by Safexpay</p>
          </div>
        </div>
      </footer>
      <Modal
        className="modal-dialog-centered modal-dialog-scrollable modal-lg"
        isOpen={open}
        toggle={toggleModel}
      >
        <button
          aria-label="Close"
          className="paybyface-closeBtn"
          data-dismiss="modal"
          type="button"
          onClick={toggleModel}
        >
          <span aria-hidden={true}>×</span>
        </button>
        <div className="modal-body">
          <div>
            <img
              src={thankyouImg}
              alt="model-img"
              className="img-fluid"
              style={{ backgroundSize: "cover", width: "100%" }}
            />
          </div>
        </div>
      </Modal>
      <Modal
        className="modal-dialog-centered modal-dialog-scrollable fail-modal"
        isOpen={open1}
        toggle={toggleModel1}
      >
        <button
          aria-label="Close"
          className="paybyface-closeBtn"
          data-dismiss="modal"
          type="button"
          onClick={toggleModel1}
        >
          <span aria-hidden={true}>×</span>
        </button>
        <div className="modal-body">
          <div className="fail-para">
          {failedRes}
          </div>
        </div>
      </Modal>
    </>
  );
};
